<template>
  <vx-card class="questionForm" no-shadow card-border>
    <div class="px-4">
      <vs-select v-if="!data.id" v-model="questionType" label="نوع السؤال" class="w-48 mb-4">
        <vs-select-item value="true/false" text="الصح والخطأ" />
        <vs-select-item value="choices" text="الإختيار من المتعدد" />
        <vs-select-item value="plain" text="سؤال مقالي" />
      </vs-select>
      <div class="w-full mb-4">
        <text-editor v-model="formData.title" placeholder="قم بكتابة السؤال ؟" with-image />
<!--        <textarea-autosize placeholder="قم بكتابة السؤال ؟" rows="2" v-model.trim="formData.title"/>-->
        <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
      </div>
      <div v-if="formData.type === 'plain'" class="mb-2">
        <text-editor v-model="formData.answer" placeholder="قم بكتابة الإجابة النموذجية للسؤال..." />
<!--        <textarea-autosize placeholder="قم بكتابة الإجابة النموذجية للسؤال..." name="answer" rows="2" v-model="formData.answer"/>-->
      </div>
      <div class="flex mb-4">
        <div class="ml-4">
          <vs-input class="w-16" label="الدرجة" v-model="formData.mark"
                    v-validate="'required|numeric'"  name="mark" data-vv-as="الدرجة" />
          <span class="text-danger text-sm" v-show="errors.has('mark')">{{ errors.first('mark') }}</span>
        </div>
      </div>
      <div v-if="formData.type !== 'plain'" class="flex items-end w-full">
        <div class="w-full">
          <div class="flex justify-between mb-4 ml-6">
            <span>الخيارات</span>
            <span>الإجابة الصحيحة</span>
          </div>

          <div v-for="(choice, index) in formData.choices" :key="index"
               class="choice-question mb-4">
            <div class="flex ml-6 justify-between p-4 border border-solid border-grey rounded-lg">
              <span v-if="editOnly || formData.type === 'true/false'">{{choice.choice_title}}</span>
              <template v-else>
                <vs-input placeholder="اكتب إجابة" v-model="choice.choice_title" :name="`title ${index+1}`" :data-vv-as="`حقل الخيار ${index + 1}`" v-validate="'required'" class="border-none text-base w-full" />
                <vs-icon v-if="formData.choices.length > 2" @click="deleteChoice(formData.choices, index)"
                         class="remove-choice" icon="icon-x" icon-pack="feather" />
              </template>

              <vs-radio v-model="formData.answer" :vs-name="formData.id || formData.title" :vs-value="index"/>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!editOnly && formData.type === 'choices' && formData.choices.length < 6" @click="formData.choices.push({choice_title: ''})"
         class="text-primary cursor-pointer ml-6 mb-4">
        <vs-icon icon="icon-plus" icon-pack="feather" />
        إضافة خيار
      </div>

    </div>

    <vs-divider />
    <div class="flex">
      <vs-button @click="close" :disabled="disableBtns" class="mr-4 ml-auto" type="flat">إلغاء</vs-button>
      <vs-button @click="submitClicked" :disabled="disableBtns">حفظ</vs-button>
    </div>
  </vx-card>
</template>

<script>
    import TextEditor from '@/views/components/TextEditor'
    export default {
      name: 'questionForm',
      components: { TextEditor },
      props: {
            data: {
                required: true,
                type: Object
            },
            editOnly: {
                type: Boolean,
                default: false
            },
            disableBtns: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            questionType(val){
                this.changeType(val)
                this.formData.type = val
            }
        },
        data() {
            return {
                questionType: this.data.type,
                formData: {
                    title: '',
                    mark: 10,
                    answer: '',
                    type: 'plain',
                    choices: []
                },
            }
        },
        methods: {
            changeType(type){
                this.formData.answer = type === 'plain' ? '' : 0
                if(type === 'true/false'){
                  this.formData.choices = [{choice_title: 'صحيح'},{choice_title: 'خطأ'}]
                } else if (type === "choices") {
                  this.formData.choices = [{choice_title: ''},{choice_title: ''}]
                } else {
                  this.formData.choices = []
                }
            },
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$emit('submit', this.formData)
                    }
                })
            },
            deleteChoice(choices, index){
                this.$delete(choices, index)
                if(this.formData.answer + 1 > this.formData.choices.length )
                    this.formData.answer--
            },
            close(){
                this.$emit('close')
            },
            intiValues(){
                this.formData.title = ''
                this.formData.mark = 10
                this.formData.answer = ''
                this.formData.type = 'plain'
                this.formData.choices = []
                this.$validator.reset()
            },
        },
        mounted(){
            this.intiValues()

            Object.assign(this.formData, this.data)
            if(this.data.choices){
                this.formData.choices = []
                this.data.choices.forEach(choice => this.formData.choices.push(Object.assign({}, choice)))
            }

            if(!this.data.id) this.changeType(this.formData.type)
        }
    }
</script>

<style lang="scss">
  .choice-question {
    .vs-con-input .vs-inputx,
    .vs-input--placeholder{
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
      border-radius: 0;
    }

    .remove-choice {
      position: absolute;
      left: 25px;
      font-size: 1.5rem;
      cursor: pointer;
      -webkit-transition: all .2s ease;
      transition: all .2s ease;
    }
  }
</style>

